var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImgAtendente(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 127.78 127.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:#25baab;}.cls-12,.cls-2{isolation:isolate;}.cls-2{opacity:0.41;}.cls-3{fill:#c59191;}.cls-4{fill:#fff;}.cls-5{fill:#ffcebf;}.cls-6{fill:#00a1d0;}.cls-7{fill:#ffb09e;}.cls-8{fill:#636d7e;}.cls-9{fill:#485367;}.cls-10{fill:#b98080;}.cls-11{fill:#ececef;}.cls-12{fill:#c3c7ce;opacity:0.61;}.cls-13{fill:#b5bac2;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "customer-service"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1045",
    "data-name": "Grupo 1045"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1044",
    "data-name": "Grupo 1044"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_400",
    "data-name": "Caminho 400",
    className: "cls-1",
    d: "M1.64,20.68a19.91,19.91,0,1,1,33,15,.86.86,0,0,0-.09,1.21.79.79,0,0,0,.22.19l3.75,2.22a.69.69,0,0,1,.25.94.71.71,0,0,1-.6.34h-17A19.9,19.9,0,0,1,1.64,20.68Z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_401",
    "data-name": "Caminho 401",
    className: "cls-2",
    d: "M38.51,39.29l-3.75-2.22a.85.85,0,0,1-.3-1.18.68.68,0,0,1,.17-.21A19.9,19.9,0,0,0,22.14.78a19.44,19.44,0,0,0-4.37.35,19.91,19.91,0,0,1,12,31.76,4.29,4.29,0,0,0,.7,6,5.33,5.33,0,0,0,.46.32l.08,0a.69.69,0,0,1-.33,1.29h7.49a.69.69,0,0,0,.69-.69.7.7,0,0,0-.34-.6Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1050",
    "data-name": "Grupo 1050"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1047",
    "data-name": "Grupo 1047"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_402",
    "data-name": "Caminho 402",
    className: "cls-3",
    d: "M98.64,73H53.48A13.32,13.32,0,0,1,43.23,51.2l.4-.48a21.27,21.27,0,0,0,4.91-13.61v-8.7a27.64,27.64,0,1,1,55.28,0v9a21.31,21.31,0,0,0,5,13.72A13.32,13.32,0,0,1,98.64,73Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_403",
    "data-name": "Caminho 403",
    className: "cls-4",
    d: "M122.38,95.41v29.85H29.74V95.63a16.66,16.66,0,0,1,10.2-15.36l15-6.5,5-2.19A10.46,10.46,0,0,0,66.22,62V60.05H85.89v1.83a10.46,10.46,0,0,0,6.34,9.61l20.23,8.67a16.68,16.68,0,0,1,9.92,15.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_404",
    "data-name": "Caminho 404",
    className: "cls-5",
    d: "M54.9,80.88a71.51,71.51,0,0,0,42.32-.4l2.44-5.8-7.42-3.19a10.46,10.46,0,0,1-6.35-9.61V60H66.23V62a10.48,10.48,0,0,1-6.3,9.6l-6,2.61Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1046",
    "data-name": "Grupo 1046"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_405",
    "data-name": "Caminho 405",
    className: "cls-6",
    d: "M112.46,80.17,97.22,73.64h0v51.62h25.16V95.41a16.67,16.67,0,0,0-9.92-15.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_406",
    "data-name": "Caminho 406",
    className: "cls-6",
    d: "M54.9,73.77v51.5H29.74V95.64a16.67,16.67,0,0,1,10.2-15.37Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1049",
    "data-name": "Grupo 1049"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_407",
    "data-name": "Caminho 407",
    className: "cls-7",
    d: "M82.88,70.84a16.44,16.44,0,0,0,6.38-1.27,10.49,10.49,0,0,1-3.37-7.69V60.05H66.22V62a10.3,10.3,0,0,1-.91,4.27,16.54,16.54,0,0,0,11.45,4.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_408",
    "data-name": "Caminho 408",
    className: "cls-5",
    d: "M95.72,30.46V46.73a16.6,16.6,0,0,1-16.6,16.6H73a16.6,16.6,0,0,1-16.6-16.6h0V30.46a10.8,10.8,0,0,1,10.8-10.8H84.92a10.81,10.81,0,0,1,10.8,10.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_409",
    "data-name": "Caminho 409",
    className: "cls-8",
    d: "M95.72,38.93l0,.06a17.47,17.47,0,0,1-6,8.92,16.64,16.64,0,0,1-6,2.94,1.88,1.88,0,0,0,.87,3.65l.08,0A20.4,20.4,0,0,0,92,50.89a20.68,20.68,0,0,0,3.7-3.72c0-.15,0-.29,0-.44V38.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_410",
    "data-name": "Caminho 410",
    className: "cls-9",
    d: "M81.65,56h-4.4a3.63,3.63,0,1,1,0-7.26h4.4a3.63,3.63,0,1,1,0,7.26Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1048",
    "data-name": "Grupo 1048"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_411",
    "data-name": "Caminho 411",
    className: "cls-10",
    d: "M80,15.36C80.4,10,85.49,6.51,90.36,4.68a27.64,27.64,0,0,1,13.46,23.73v1.9l-1.33.24a22.33,22.33,0,0,1-6.53,0C85.9,29.21,79.47,21.78,80,15.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_412",
    "data-name": "Caminho 412",
    className: "cls-3",
    d: "M76.18.77A27.5,27.5,0,0,1,92.81,6.33,49.26,49.26,0,0,1,75.26,24.16a49,49,0,0,1-18.62,6.39h-8.1V28.41A27.64,27.64,0,0,1,76.18.77Z"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_413",
    "data-name": "Caminho 413",
    className: "cls-11",
    d: "M107.07,125.26H46.94L43.62,94A3.76,3.76,0,0,1,47,89.84l.4,0h59.3a3.75,3.75,0,0,1,3.75,3.76,2.55,2.55,0,0,1,0,.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_414",
    "data-name": "Caminho 414",
    className: "cls-12",
    d: "M106.66,89.82H99.14a3.75,3.75,0,0,1,3.76,3.75c0,.14,0,.27,0,.4l-3.32,31.29h7.51L110.39,94a3.75,3.75,0,0,0-3.34-4.13A2.55,2.55,0,0,0,106.66,89.82Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1051",
    "data-name": "Grupo 1051"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_415",
    "data-name": "Caminho 415",
    className: "cls-13",
    d: "M125.22,127.14H2.55a1.85,1.85,0,0,1,0-3.7H125.22a1.85,1.85,0,0,1,0,3.7Z"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_41",
    "data-name": "Elipse 41",
    className: "cls-13",
    cx: 77.01,
    cy: 107.54,
    r: 5.26
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1052",
    "data-name": "Grupo 1052"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_42",
    "data-name": "Elipse 42",
    className: "cls-4",
    cx: 14.04,
    cy: 20.68,
    r: 1.88
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_43",
    "data-name": "Elipse 43",
    className: "cls-4",
    cx: 21.55,
    cy: 20.68,
    r: 1.88
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_44",
    "data-name": "Elipse 44",
    className: "cls-4",
    cx: 29.06,
    cy: 20.68,
    r: 1.88
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgAtendente);
export default __webpack_public_path__ + "static/media/img-atendente.47d4990d.svg";
export { ForwardRef as ReactComponent };